import React from "react";
import { Paragraph, Text, Link } from "components/core/Typography";

const PhoneAndEmail = () => (
	<>
		<Text>
			<Paragraph
				weight="bold"
				size="medium"
				last
			>
				Telephone:
			</Paragraph>
			<Paragraph size="standard">(512) 705-6208</Paragraph>
		</Text>
		<Text>
			<Paragraph
				weight="bold"
				last
			>
				Email Us:
			</Paragraph>
			<Link
				href="mailto:customerhelp@storage.com"
				size="standard"
				className="no-underline"
			>
				customerhelp@storage.com
			</Link>
		</Text>
	</>
);

export default PhoneAndEmail;
